// import { motion } from "framer-motion";

// const primaryValues = [
//   {
//     title: "Engineering over hype",
//     desc: "We solve problems with systems, not slogans. Code quality and architecture come first.",
//   },
//   {
//     title: "Ownership is default",
//     desc: "Every engineer owns what they ship — reliability, performance, and long-term maintainability.",
//   },
// ];

// const secondaryValues = [
//   {
//     title: "Scale is a responsibility",
//     desc: "We design systems assuming success — performance, security, and extensibility are non-negotiable.",
//   },
//   {
//     title: "Clarity beats cleverness",
//     desc: "Readable code, clear decisions, and simple abstractions outperform complexity every time.",
//   },
// ];

// const Culture = () => {
//   return (
//     //<section className="pt-16 pb-14 bg-white">
//    <section className="pt-[140px] pb-14 bg-white">
//       <div className="max-w-7xl mx-auto px-6">

//         {/* TOP BLOCK */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">

//           {/* LEFT */}
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.5 }}
//           >
//             <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 leading-tight">
//               Culture is not benefits.
//               <br />
//               <span className="text-[#CDA454]">
//                 It’s how we build software.
//               </span>
//             </h2>

//             <p className="mt-6 text-lg text-gray-600 max-w-xl">
//               Valsco Technology is built by engineers who value clean architecture,
//               system thinking, and software that survives real-world scale.
//             </p>

//             {/* PRIMARY VALUES */}
//             <div className="mt-10 space-y-6">
//               {primaryValues.map((item, i) => (
//                 <div key={i} className="border-l-4 border-[#CDA454] pl-4">
//                   <h4 className="text-base font-semibold text-gray-900">
//                     {item.title}
//                   </h4>
//                   <p className="text-sm text-gray-600 mt-1">
//                     {item.desc}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </motion.div>

//           {/* RIGHT – IMAGE */}
//           <motion.div
//             initial={{ opacity: 0, scale: 0.96 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.5 }}
//             className="relative"
//           >
//             <div className="rounded-[28px] overflow-hidden border border-gray-200 shadow-xl">
//               <img
//                 src="culture-valsco.png"
//                 alt="Valsco engineering culture"
//                 className="w-full h-full object-cover"
//               />
//             </div>

//             <div className="absolute -bottom-5 left-6 bg-white px-4 py-2 rounded-xl shadow-md text-sm font-medium">
//               Built by engineers, for scale
//             </div>
//           </motion.div>
//         </div>

//         {/* SECONDARY VALUES */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {secondaryValues.map((item, index) => (
//             <motion.div
//               key={index}
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ delay: index * 0.1 }}
//               className="p-8 rounded-2xl border border-gray-200 bg-gray-50"
//             >
//               <h4 className="text-lg font-semibold text-gray-900 mb-2">
//                 {item.title}
//               </h4>
//               <p className="text-sm text-gray-600 leading-relaxed">
//                 {item.desc}
//               </p>
//             </motion.div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default Culture;


















// import { motion } from "framer-motion";

// const values = [
//   {
//     title: "Engineering over hype",
//     desc: "We solve problems with systems, not slogans. Code quality and architecture come first.",
//   },
//   {
//     title: "Ownership is default",
//     desc: "Every engineer owns what they ship — reliability, performance, and long-term maintainability.",
//   },
//   {
//     title: "Scale is a responsibility",
//     desc: "We design systems assuming success — performance, security, and extensibility are non-negotiable.",
//   },
//   {
//     title: "Clarity beats cleverness",
//     desc: "Readable code, clear decisions, and simple abstractions outperform complexity every time.",
//   },
// ];

// const Culture = () => {
//   return (
//     <section className="relative bg-white overflow-hidden">

//       {/* 🔥 PREMIUM BACKGROUND */}
//       <div className="absolute inset-0 opacity-[0.04]"
//         style={{
//           backgroundImage:
//             "radial-gradient(circle at 1px 1px, #cda454 1px, transparent 1px)",
//           backgroundSize: "30px 30px",
//         }}
//       />

//       {/* GOLD GLOW */}
//       <div className="absolute top-[-200px] left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#cda454]/20 blur-[140px] rounded-full" />

//       <div className="max-w-7xl mx-auto px-6 pt-[150px] pb-32 relative z-10">

//         {/* 🔥 HERO */}
//         <div className="grid lg:grid-cols-2 gap-20 items-center">

//           {/* LEFT TEXT */}
//           <motion.div
//             initial={{ opacity: 0, y: 60 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             className="max-w-xl"
//           >
//             <h1 className="text-[40px] sm:text-[64px] font-extrabold leading-tight text-[#111]">
//               Culture is not perks.
//               <span className="block text-[#cda454]">
//                 It’s our operating system.
//               </span>
//             </h1>

//             <p className="mt-6 text-[#555] text-[18px] leading-relaxed">
//               At Valsco, culture is how decisions are made, how systems are built,
//               and how responsibility is taken. It defines how we ship, scale,
//               and sustain real-world software.
//             </p>

//             {/* MINI TAGS */}
//             <div className="mt-8 flex gap-3 flex-wrap">
//               {["Systems Thinking", "Clean Architecture", "Ownership", "Scale"].map((tag, i) => (
//                 <span
//                   key={i}
//                   className="px-4 py-1 text-sm rounded-full border border-[#cda454]/30 text-[#cda454]"
//                 >
//                   {tag}
//                 </span>
//               ))}
//             </div>
//           </motion.div>

//           {/* RIGHT VISUAL STACK */}
//           <div className="relative h-[500px] hidden lg:block">

//             {values.slice(0, 3).map((item, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 40 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: i * 0.2 }}
//                 whileHover={{ scale: 1.04 }}
//                 className="absolute w-[300px] p-6 rounded-2xl
//                 bg-white/70 backdrop-blur-xl
//                 border border-[#cda454]/10
//                 shadow-xl"
//                 style={{
//                   top: `${i * 90}px`,
//                   left: `${i * 60}px`,
//                 }}
//               >
//                 <h3 className="font-semibold text-[#111] mb-2">
//                   {item.title}
//                 </h3>
//                 <p className="text-sm text-[#555]">
//                   {item.desc}
//                 </p>
//               </motion.div>
//             ))}

//           </div>
//         </div>

//         {/* 🔥 STATEMENT BLOCK */}
//         <motion.div
//           initial={{ opacity: 0, scale: 0.95 }}
//           whileInView={{ opacity: 1, scale: 1 }}
//           className="mt-32 text-center max-w-4xl mx-auto"
//         >
//           <h2 className="text-[32px] sm:text-[48px] font-bold text-[#111] leading-tight">
//             We don’t chase speed.
//             <span className="block text-[#cda454]">
//               We build for longevity.
//             </span>
//           </h2>

//           <p className="mt-6 text-[#666] text-lg">
//             Every system we design is meant to handle complexity, scale,
//             and long-term evolution — not just immediate delivery.
//           </p>
//         </motion.div>

//         {/* 🔥 STACKED CARDS (BEST PART) */}
//         <div className="mt-24 space-y-10 max-w-4xl mx-auto">

//           {values.map((item, i) => (
//             <motion.div
//               key={i}
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               whileHover={{ scale: 1.02 }}
//               transition={{ delay: i * 0.15 }}
//               className="group relative p-10 rounded-3xl
//               bg-white/80 backdrop-blur-xl
//               border border-[#cda454]/10
//               shadow-lg hover:shadow-2xl transition duration-500"
//             >
//               {/* Glow on hover */}
//               <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition">
//                 <div className="absolute inset-0 bg-[#cda454]/5 blur-2xl rounded-3xl" />
//               </div>

//               <h3 className="text-[22px] font-semibold text-[#111]">
//                 {item.title}
//               </h3>

//               <p className="mt-3 text-[#555] leading-relaxed">
//                 {item.desc}
//               </p>
//             </motion.div>
//           ))}
//         </div>

//         {/* 🔥 IMAGE SECTION */}
//         <motion.div
//           initial={{ opacity: 0, y: 80 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           className="mt-32 relative"
//         >
//           <div className="rounded-[32px] overflow-hidden shadow-2xl">
//             <img
//               src="/culture-valsco.png"
//               className="w-full h-[400px] object-cover"
//             />
//           </div>

//           {/* Floating badge */}
//           <div className="absolute bottom-6 left-6 bg-white/80 backdrop-blur-md px-5 py-2 rounded-xl shadow-md border border-[#e5e7eb]">
//             Built by engineers ⚖️
//           </div>
//         </motion.div>

//       </div>
//     </section>
//   );
// };

// export default Culture;










import { motion } from "framer-motion";

const primaryValues = [
  {
    title: "Engineering over hype",
    desc: "We solve problems with systems, not slogans. Code quality and architecture come first.",
  },
  {
    title: "Ownership is default",
    desc: "Every engineer owns what they ship reliability, performance, and long-term maintainability.",
  },
];

const secondaryValues = [
  {
    title: "Scale is a responsibility",
    desc: "We design systems assuming success performance, security, and extensibility are non-negotiable.",
  },
  {
    title: "Clarity beats cleverness",
    desc: "Readable code, clear decisions, and simple abstractions outperform complexity every time.",
  },
];

const Culture = () => {
  return (
    <section className="relative pt-[140px] pb-24 bg-white overflow-hidden">

      {/* 🔥 PREMIUM BACKGROUND TEXTURE */}
      <div
        className="absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #CDA454 1px, transparent 1px)",
          backgroundSize: "26px 26px",
        }}
      />

      {/* GOLD LIGHT */}
      {/* <div className="absolute top-[-150px] left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-[#CDA454]/10 blur-[120px] rounded-full" /> */}

      <div className="max-w-7xl mx-auto px-6 relative z-10">

        {/* 🔥 HERO */}
        <div className="grid lg:grid-cols-2 gap-20 items-center mb-32">

          {/* LEFT */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="text-[40px] sm:text-[58px] font-bold text-[#111] leading-tight tracking-tight">
              Culture is not benefits.
              <span className="block text-[#CDA454]">
                It’s how we build software.
              </span>
            </h2>

            <p className="mt-6 text-[#555] text-[18px] max-w-xl leading-relaxed">
              Jurident is built by engineers who value clean architecture,
              system thinking, and software that survives real-world scale.
            </p>

            {/* 🔥 PRIMARY VALUES */}
            <div className="mt-14 space-y-8">
              {primaryValues.map((item, i) => (
                <motion.div
                  key={i}
                  whileHover={{ x: 8 }}
                  className="group flex gap-5"
                >
                  {/* GOLD ACCENT */}
                  <div className="w-[4px] bg-gradient-to-b from-[#CDA454] to-transparent rounded-full" />

                  <div>
                    <h4 className="text-lg font-semibold text-[#111] group-hover:text-[#CDA454] transition">
                      {item.title}
                    </h4>
                    <p className="text-sm text-[#555] mt-2 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* RIGHT IMAGE */}
          <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7 }}
            className="relative group"
          >
            {/* LIGHT GLOW */}
            <div className="absolute inset-0 bg-[#CDA454]/10 blur-3xl rounded-[40px] opacity-0 group-hover:opacity-100 transition duration-500" />

            <div className="relative rounded-[36px] overflow-hidden border border-gray-200 shadow-[0_30px_80px_rgba(0,0,0,0.12)]">
              <img
                src="culture-valsco.png"
                className="w-full h-full object-cover group-hover:scale-105 transition duration-700"
              />
            </div>

            {/* FLOATING BADGE */}
           <div className="absolute bottom-6 left-6 bg-[#111]/90 backdrop-blur-xl px-6 py-2 rounded-xl shadow-lg border border-white/10 text-sm font-medium text-white">
  Built by engineers, for scale
</div>
          </motion.div>
        </div>

        {/* 🔥 SECONDARY VALUES */}
        <div className="grid md:grid-cols-2 gap-12">

          {secondaryValues.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.15 }}
              className="group relative p-10 rounded-[28px]
              bg-white border border-gray-200
              shadow-[0_20px_60px_rgba(0,0,0,0.08)]
              hover:shadow-[0_30px_80px_rgba(0,0,0,0.12)]
              transition duration-500 overflow-hidden"
            >

              {/* LIGHT SWEEP EFFECT */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-700">
                <div className="absolute -left-1/2 top-0 w-1/2 h-full bg-[#CDA454]/20 blur-xl rotate-12 translate-x-[-100%] group-hover:translate-x-[200%] transition duration-1000" />
              </div>

              {/* TOP ACCENT */}
              <div className="w-14 h-[3px] bg-[#CDA454] mb-6 rounded-full" />

              <h4 className="text-xl font-semibold text-[#111] mb-3">
                {item.title}
              </h4>

              <p className="text-[#555] leading-relaxed">
                {item.desc}
              </p>

            </motion.div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default Culture;